import { cloneElement, FC, JSX, MouseEvent } from 'react';
import { useShowstopper } from '../../../context/contexts/ShowstopperProvider';

import { ShowstopperLockedFeatureDisplayConfig } from './types';

interface LockedFeatureShowstopperProps {
    showstopperProps: ShowstopperLockedFeatureDisplayConfig['showstopperProps'];
    children: JSX.Element;
    className?: string;
}

const LockedFeatureShowstopper: FC<LockedFeatureShowstopperProps> = ({ showstopperProps, children, className }) => {
    const { openShowstopper } = useShowstopper();
    const onClick = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        openShowstopper(showstopperProps);
    };
    return (
        <div onClick={onClick} className={className}>
            {cloneElement(children, {
                className: [children.props?.className, 'pointer-events-none'].filter(Boolean).join(' ')
            })}
        </div>
    );
};

export default LockedFeatureShowstopper;
